import useJwt from '@src/auth/jwt/useJwt'
import axios from 'axios'
import { isUserLoggedIn } from '@utils'

const config = useJwt.jwtConfig

export const contarTempo = () => {

  if (isUserLoggedIn() !== null) {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const tempo = 10

    const dado = userData.user.usu_id
    const id = userData.id

    return async dispatch => {
      await axios.post(`${process.env.REACT_APP_ADM_API_URL}contar/${dado}/${id}/${tempo}`)
        .then(response => {
          dispatch({
            type: 'CONTAR'
          })
        }).catch(error => {
          dispatch({
            type: 'ERROS'
          })
        })
    }
  }
}

export const handleLogin = (userData, history) => {
  //Restaura skin backup no local correto do localStorage

  return async dispatch => {
    await axios.post(`${process.env.REACT_APP_ADM_API_URL}auth/login`, userData)
      .then(response => {
        dispatch({
          type: 'LOGIN',
          data: response.data,
          config,
          [config.storageTokenKeyName]: response.access_token,
          [config.storageRefreshTokenKeyName]: response.refresh_token
        })

        localStorage.setItem("userData", JSON.stringify(response.data))

        contarTempo()

        if (history) {
          history.push('/livros')
        }
      }).catch(error => {
        dispatch({
          type: 'ERROS',
          erros: error.response.data.errors,
          error: error.response.data.error
        })
        // Toastfy(['error', error.response.data.error])
      })
  }
}

export const handleAutomaticLogin = (userData, history) => {

  //Restaura skin backup no local correto do localStorage

  return async dispatch => {
    await axios.post(`${process.env.REACT_APP_ADM_API_URL}parceiro/conectar/aluno`, userData)
      .then(response => {
        dispatch({
          type: 'LOGIN',
          data: response.data,
          config,
          [config.storageTokenKeyName]: response.access_token,
          [config.storageRefreshTokenKeyName]: response.refresh_token
        })

        localStorage.setItem("userData", JSON.stringify(response.data))

        contarTempo()

        if (history) {
          history.push('/livros')
        }
      }).catch(error => {
        dispatch({
          type: 'ERROS',
          erros: error.response.data.errors,
          error: error.response.data.error
        })
        // Toastfy(['error', error.response.data.error])
      })
  }
}

export const handleRecuperarSenha = (user, history) => {
  return async dispatch => {
    await axios.get(`${process.env.REACT_APP_ADM_API_URL}recuperar-senha-email/${user.usu_email}`)
      .then(response => {
        dispatch({
          type: 'RECUPERAR-SENHA',
          data: response.data
        })

        history.replace('/Login')
      }).catch(error => {
        dispatch({
          type: 'ERROS',
          erros: error.response.data.error
        })
        // Toastfy(['error', error.response.data.error])
      })
  }
}

export const handleLogout = () => {
  //Força o tema para Light e faz backup do tema definido pelo usuário

  return dispatch => {
    dispatch({ type: 'LOGOUT', [config.storageTokenKeyName]: null, [config.storageRefreshTokenKeyName]: null })
    localStorage.removeItem('userData')
    localStorage.removeItem('leitura')
    localStorage.removeItem(config.storageTokenKeyName)
    localStorage.removeItem(config.storageRefreshTokenKeyName)
  }
}

export const handleRefresh = () => {
  axios.post(`${process.env.REACT_APP_ADM_API_URL}refresh-token`)
    .then(response => {
      localStorage.setItem("userData", JSON.stringify(response.data))
      return true;
    }).catch(error => {
      return false;
    })
}
